import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardArrowUpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_arrow_up"}/>
}
